import { render } from "./PlumbingSetup.vue?vue&type=template&id=56bee09f&scoped=true"
import script from "./PlumbingSetup.vue?vue&type=script&lang=js"
export * from "./PlumbingSetup.vue?vue&type=script&lang=js"

import "./PlumbingSetup.vue?vue&type=style&index=0&id=56bee09f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56bee09f"]])

export default __exports__